import React from "react";
import under_construction from "./under_construction.json";
import Lottie from "lottie-react";
import { Box, Container, styled } from "@mui/system";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import translations from "translations";
import { CtaPrimary } from "@mlpa/core-ui-core-open_ocean_ui/Molecules/Buttons/CtaPrimary";

const StyledUnderConstructionContainer = styled(Container)({
  height: "500px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "5rem",
  display: "flex",
});

const UnderConstruction: React.FC<{ label: string }> = (props) => {
  const navigate = useNavigate();
  return (
    <StyledUnderConstructionContainer>
      <Box sx={{ display: "flex", justifyContent: "center", gap: "1rem", alignItems: "center" }}>
        <Typography variant="h6">{translations.pages.development.label}</Typography>
        <Typography variant="h6">{`${props.label} ${translations.pages.development.notAvailable}`}</Typography>
        <CtaPrimary onClick={() => navigate(-1)}>Go Back</CtaPrimary>
      </Box>
      <Container maxWidth="sm">
        <Box>
          <Lottie animationData={under_construction} />
        </Box>
      </Container>
    </StyledUnderConstructionContainer>
  );
};

export default UnderConstruction;
